export default function blockBrands() {
  document.querySelectorAll( '.block-brands' ).forEach( function( block ) {

    // block.querySelectorAll( '.brands-categories__button' ).
    //     forEach( function( item ) {
    //       item.addEventListener( 'click', function( e ) {
    //         let index = item.dataset.index;
    //         block.querySelectorAll( '.brands-categories__button--active' ).
    //             forEach( i => i.classList.remove(
    //                 'brands-categories__button--active' ) );
    //
    //         block.querySelectorAll('.brands-list__item--active' ).forEach(
    //             i => i.classList.remove( 'brands-list__item--active' ) );
    //
    //         item.classList.add( 'brands-categories__button--active' );
    //
    //         block.querySelectorAll('.brands-list__category--active').forEach( i => i.classList.remove(
    //             'brands-list__category--active' ) );
    //
    //         block.querySelector('.brands-list__category[data-index="'+index+'"]').classList.add('brands-list__category--active');
    //
    //       } );
    //     } );

    block.querySelectorAll( '.brands-list__item' ).forEach( function( item ) {
      item.addEventListener( 'click', function( e ) {
        let status = item.classList.contains( 'brands-list__item--active' );
        let delay = 0;
        if (status) { // if item is active
          item.classList.remove( 'brands-list__item--active' );
        } else {
          var otherActivated = block.querySelectorAll(
              '.brands-list__item--active' );
          if (otherActivated.length > 0) {
            delay = 600;
            otherActivated.forEach(
                i => i.classList.remove( 'brands-list__item--active' ) );
          }
          setTimeout( function() {
            if(!item.classList.contains('brands-list__item--no-desc')) {
              item.classList.add( 'brands-list__item--active' );
            }
          }, delay );
        }
      } );
    } );
  } );

}